import {DataObjectId, noBoardContainerId} from 'yougile-model'
import {addingAllowed, moveAllowed} from '@client/hub-actions-allowed'
import {Sync} from '@client/sync'
import {
  showErrorCannotCreateMirrorFromSubtask,
  showErrorNotAllowedCreateMirror
} from './show-errors'

interface Props {
  taskId: DataObjectId
  location?: DataObjectId
}

// еще проверяются права при клике в task-card-drag.tsx в onMouseDown

const canCreateMirroredTask = (props: Props): boolean => {
  const {taskId, location} = props

  const box = Sync.getCurrentSandbox()
  const task = box.getHub(taskId)
  if (!task || !location) {
    return false
  }

  // Создание зеркала возможно если
  // 1. Есть права на создание в колонке, где находится оригинал
  // 2. Есть права на перемещение из колонки, где находится оригинал
  // 3. Есть права на создание, куда создается зеркало
  // * не учитываются права на перемещение, куда создается зеркало

  return (
    addingAllowed(task.location) &&
    moveAllowed(task.id, task.location, location)
  )
}

export const canCreateMirroredTaskWithError = (props: Props): boolean => {
  const {taskId, location} = props

  const box = Sync.getCurrentSandbox()
  const task = box.getHub(taskId)
  if (!task) {
    return false
  }

  if (task.location === noBoardContainerId) {
    showErrorCannotCreateMirrorFromSubtask()
    return false
  }

  if (!canCreateMirroredTask({taskId, location})) {
    showErrorNotAllowedCreateMirror()
    return false
  }

  return true
}
